

$(window).scroll(function() {
   $(".bountiful-floating-block").removeClass("unfixed");
   $(".bountiful-floating-block").removeClass("unfixed-tablet");
   if($(window).scrollTop() + $(window).height() > ($(document).height() - 600) ) {
       //you are at bottom
       $(".bountiful-floating-block").addClass("unfixed");
   }
   if($(window).scrollTop() + $(window).height() > ($(document).height() - 800) ) {
       //you are at bottom
       $(".bountiful-floating-block").addClass("unfixed-tablet");
   }
});

$(window).scroll(function() {
   $(".plantgenius-floating-block").removeClass("unfixed");
   $(".plantgenius-floating-block").removeClass("unfixed-tablet");
   if($(window).scrollTop() + $(window).height() > ($(document).height() - 500) ) {
       //you are at bottom
       $(".plantgenius-floating-block").addClass("unfixed");
   }
   if($(window).scrollTop() + $(window).height() > ($(document).height() - 700) ) {
       //you are at bottom
       $(".plantgenius-floating-block").addClass("unfixed-tablet");
   }
});

$(window).scroll(function() {
   $(".mounatain-dew-o-floating-block").removeClass("unfixed");
   $(".mounatain-dew-o-floating-block").removeClass("unfixed-tablet");
   if($(window).scrollTop() + $(window).height() > ($(document).height() - 660) ) {
       //you are at bottom
       $(".mounatain-dew-o-floating-block").addClass("unfixed");
   }
   if($(window).scrollTop() + $(window).height() > ($(document).height() - 800) ) {
       //you are at bottom
       $(".mounatain-dew-o-floating-block").addClass("unfixed-tablet");
   }
});


$(window).scroll(function() {
  var scroll = $(window).scrollTop();

  if (scroll >= 400) {
    $(".floating-atc").addClass("active");
  } else {
    $(".floating-atc").removeClass("active");
  }
  if (scroll >= 1375) {
    $(".floating-atc").addClass("active-tablet");
  } else {
    $(".floating-atc").removeClass("active-tablet");
  }
  if (scroll >= 1150) {
    $(".floating-atc").addClass("active-tablet-small");
  } else {
    $(".floating-atc").removeClass("active-tablet-small");
  }
  if (scroll >= 1000) {
    $(".floating-atc").addClass("active-mobile");
  } else {
    $(".floating-atc").removeClass("active-mobile");
  }
  if (scroll >= 800) {
    $(".floating-atc").addClass("active-mobile-xs");
  } else {
    $(".floating-atc").removeClass("active-mobile-xs");
  }
});

// BV - hide ReCharge options when trial size variant is selected, and update floating ATC bar with variant price. 
$(function() {
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    console.log(variant);
    var rc_element = $('.ProductForm .ro_widget');
    var floating_atc_price_element = $('.floating-atc .floating-atc-price .ProductMeta__Price.Price');
    
    // update price of floating ATC bar
    floating_atc_price_element.text(Shopify.formatMoney(variant.price));
    
    // hide/show recharge options
    if (rc_element.length && variant && variant.title.toLowerCase().includes('trial size')) {
      rc_element.addClass('hidden');
    } else {
      rc_element.removeClass('hidden');
    }
  });
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

$(function() {
const sidebar = $('#sidebar-container');
  if(document.getElementById('sidebar-container')){
        const widget = $('#our-story-nav');
        const footer = $('#shopify-section-footer');
        const space = 1; // arbitrary value to create space between the window and widget
        const startTop = sidebar.offset().top + 1; // arbitrary start top position
        const endTop = footer.offset().top - widget.height() - space;

        widget.css('top', startTop);

        $(window).scroll(function() {

        let windowTop = $(this).scrollTop();
        let widgetTop = widget.offset().top;
        let newTop = startTop;

// update this condition to change hide logic
        if(windowTop >= (footer.offset().top-600)){
            widget[0].style.opacity = "0";
        } else {
            widget[0].style.opacity = "1";
        }

        if (widgetTop >= startTop && widgetTop <= endTop) {
        if (windowTop > startTop - space && windowTop < endTop - space) {
        newTop = windowTop + space;
        } else if (windowTop > endTop - space) {
        newTop = endTop;
        }
        widget.stop().animate({
        'top': newTop
        });
        }

        });
  }
});



$(function() {
  var active_link = $('.wild-plants-link');
if(document.getElementById('who-we-are')){
  var founderThreshold = $("#who-we-are").offset().top - 40;
  var plantsThreshold = $("#wild-plants-and-clinical-ingredients").offset().top - 40; 
  var sustainabilityThreshold = $("#sustainability").offset().top - 40;

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= sustainabilityThreshold) {
      $('.side-nav-link').removeClass('active');
      $('.sustainability-link').addClass('active');
    } else if (scroll >= plantsThreshold && scroll < sustainabilityThreshold) {
      $('.side-nav-link').removeClass('active');
      $('.wild-plants-link').addClass('active');
    } else if (scroll >= founderThreshold && scroll < plantsThreshold) {
      $('.side-nav-link').removeClass('active');
      $('.our-founder-link').addClass('active');
    }
  });
}
});

/*
var initialTopOffset = $('.headline').offset().top;
$(window).scroll(function(event) {
  var scroll = $(window).scrollTop();
  // if the top of our browser is inside the section2
  if (scroll >= $('.section2').offset().top && scroll + initialTopOffset <= $('.section2').offset().top + $('.section2').outerHeight()) {
    $('nav').addClass('light-mode'); // add the class
  } else {
    $('nav').removeClass('light-mode'); // remove the class
  }
});*/
/*
$(window).scroll(); */ //ensure if you're in current position when page is refreshed

/*$('.product__media-container').css('align-items', 'flex-start');

$('.product-thumbnails, .product-thumbnails__viewport').css('max-height', $('.product__media').height()+'px');*/

/*function updatePrice(){
  var prices = document.querySelectorAll('.product__price span');
  
  
  if (!prices)return;
  
  for (var each of prices){
    each.innerText = each.innerText.replace('.00', '');
  }
}

window.onload = function() {
  setTimeout(updatePrice, 50);
}*/